import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { useToast } from '@chakra-ui/react'

import { resetUpdateDsrOutcome } from '../actions/dsr-actions'
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import { triggerLaunchdeckToast } from '../../global/helpers/global-helpers'
import { updateDsrTemplate } from '../actions/dsr-template-actions'
import { removeEmptySubWidgets, removeEmptyWidgets } from '../helpers/dsr-draft-helpers'


function SaveDsrTemplateButton({
    dsrTemplateId, 
    dsrPages, 
    updateDsrTemplate, 
    updateDsrTemplateOutcome, 
    isMobileView
  }) {
  const toast = useToast();
  const [saveButtonUsed, setSaveButtonUsed] = useState(false)


  useEffect(() => {
    if (updateDsrTemplateOutcome) {
      const {updateDsrTemplateStatus, updatedDsrTemplateId, sourceEvent} = updateDsrTemplateOutcome || {};
     
      if ( sourceEvent==="save-dsr-template" && saveButtonUsed) {
        if (updateDsrTemplateStatus && updatedDsrTemplateId === dsrTemplateId && dsrTemplateId !== undefined) {
          toast(
            triggerLaunchdeckToast({
            useCase: "show-success-state",
            bannerText: "Template saved",
            label: "We've also cleared away empty content blocks for your convenience", 
            isMobileView
            })
          )

        } else if (!updateDsrTemplateStatus) {
          toast(
            triggerLaunchdeckToast({
            useCase: "show-error-state",
            label: "Unfortunately something went wrong. Please try again later.", 
            isMobileView
            })
          )
        }
  
          resetUpdateDsrOutcome()
          setSaveButtonUsed(false)
      }
      }
  }, [updateDsrTemplateOutcome, toast, dsrTemplateId]);

  function handleClick() {
    setSaveButtonUsed(true)

    const clearedWidgets = removeEmptySubWidgets(dsrPages);
    const filteredDsrPagesLocalState= removeEmptyWidgets(clearedWidgets);

    updateDsrTemplate({
      dsrTemplateId,
      // Note: Future scope - save only the parts that have changed, and not all the pages. Less risk of wiping out error data.
      dsrPages: filteredDsrPagesLocalState,
      sourceEvent: 'save-dsr-template'
    })
  }

  return (
    <LaunchdeckButton bg='brandGreen.500' color='white' onClick={() => handleClick()} label='Save' />
							
  );
}

function mapStateToProps(state) {
  return {
    updateDsrTemplateOutcome: state.updateDsrTemplateOutcome.results.data,
    isMobileView: state.mobileViewMode.isMobileView
  };
}


const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
      resetUpdateDsrOutcome,
      updateDsrTemplate
		},
		dispatch,
	)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SaveDsrTemplateButton));
